var _        = require('underscore');
var $        = require('jquery');

var Core        = require('../core/core.js');
var VersionItem = require('./sidebar__versions__item.js');
var DraftItem   = require('./sidebar__versions__draft.js');
/**
 * Creates a sidebar
 *
 * @class
 */

class SidebarVersions extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {}
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="editor__sidebar__versions js-editor__sidebar__versions">
                <div class="editor__sidebar__versions__header clearfix">
                    <div class="editor__sidebar__versions__header__title">Version History</div>
                    <div class="editor__sidebar__versions__header__close js-editor__sidebar__versions__header__close btn__icon cio-ui-icon"><%= embedded_svg('icon-cancel.svg') %></div>
                </div>
                <div class="editor__sidebar__versions__inner js-editor__sidebar__versions__draft__item"></div>
                <div class="editor__sidebar__versions__header clearfix">
                    <div class="editor__sidebar__versions__header__title">Previous Versions</div>
                </div>
                <div class="editor__sidebar__versions__inner js-editor__sidebar__versions__previous"></div>
            </div>
        `;

        super.render();

        $('.js-editor__sidebar__versions__header__close', this.$el).on('click', this._closeButtonClicked);
    }

    _closeButtonClicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:VersionsSidebar:Close');
    }

    /**
     * Adds a groups interface to the sidebar
     */
    addDraftItem(name_placeholder){
        return new DraftItem({
            target: $('.js-editor__sidebar__versions__draft__item', this.$el),
            fields: {
                name_placeholder: name_placeholder
            }
        });
    }

    addVersionItem(name, description, time){
        return new VersionItem({
            target: $('.js-editor__sidebar__versions__previous', this.$el),
            fields: {
                "name": name,
                "description": description,
                "time": time
            }
        });
    }

}
module.exports = SidebarVersions;